(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lumilash-native-menu"] && !Shopify.designMode) return;
  try {
    function initializeLumilashMenus(root) {
    root.querySelectorAll('.lm-nav').forEach((nav) => {
      if (nav.dataset.initialized) return;
      nav.dataset.initialized = 'true';
      const disclosures = [...nav.querySelectorAll('.lm-disclosure')];
      disclosures.forEach((details) => {
        const item = details.closest('.lm-item');
        const summary = details.querySelector('summary');
        let timer;
        const close = () => { clearTimeout(timer); details.open = false; summary.setAttribute('aria-expanded', 'false'); };
        details.addEventListener('toggle', () => {
          summary.setAttribute('aria-expanded', String(details.open));
          if (details.open) disclosures.forEach((other) => { if (other !== details) other.open = false; });
        });
        summary.setAttribute('aria-expanded', String(details.open));
        item.addEventListener('pointerenter', (event) => {
          if (event.pointerType !== 'mouse' || details.classList.contains('lm-search')) return;
          clearTimeout(timer);
          timer = setTimeout(() => { details.open = true; }, 150);
        });
        item.addEventListener('pointerleave', (event) => {
          if (event.pointerType !== 'mouse') return;
          clearTimeout(timer);
          if (!item.contains(document.activeElement)) timer = setTimeout(close, 150);
        });
        item.addEventListener('focusout', () => {
          requestAnimationFrame(() => { if (!item.contains(document.activeElement)) close(); });
        });
      });
      nav.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        const open = nav.querySelector('.lm-disclosure[open]');
        if (!open) return;
        open.open = false;
        open.querySelector('summary').focus();
        event.stopPropagation();
      });
    });
  }
  initializeLumilashMenus(document);
  document.addEventListener('shopify:section:load', (event) => initializeLumilashMenus(event.target));
  document.addEventListener('click', (event) => {
    document.querySelectorAll('.lm-disclosure[open]').forEach((details) => {
      if (!details.closest('.lm-item').contains(event.target)) details.open = false;
    });
  });
  } catch(e) { console.error(e); }
})();

})();
